import { Chip } from '@mui/material';
import React from 'react';
import styled from 'styled-components';
import { Color } from '../../../../types';

export const forwardRefSimply = <T extends {}>(
  Component: React.ComponentType<React.PropsWithChildren<T>>
) => {
  return React.forwardRef<
    React.RefObject<typeof Component>,
    React.ComponentProps<typeof Component>
  >((props, ref) => (
    // @ts-ignore
    <Component {...props} ref={ref} />
  ));
};

const StyledChip = forwardRefSimply(styled(Chip)<{
  $chipColor: string;
}>`
  margin: 4px;
  color: ${(props) => props.$chipColor};
  border-color: ${(props) => props.$chipColor};
  & .deleteIcon {
    color: ${(props) => props.$chipColor};
  }
`);

interface FilterPillProps {
  label: string;
  color: Color;
  onDelete?: () => void;
}

export const FilterPill = (props: FilterPillProps) => {
  const { label, color, onDelete } = props;
  return (
    <StyledChip
      onDelete={() => onDelete?.()}
      variant="outlined"
      label={label}
      $chipColor={color}
      classes={{ deleteIcon: 'deleteIcon' }}
    />
  );
};
